"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicVideoApiService = void 0;
var tslib_1 = require("tslib");
var video_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/video/video");
var to_error_1 = require("../../parsers/to-error");
var hosts_1 = require("@wix/wix-vod-constants/dist/env/hosts");
var experiments_1 = require("@wix/wix-vod-shared/dist/src/common/utils/experiments");
var public_1 = require("@wix/wix-vod-gql-api/public");
var PublicVideoApiService = /** @class */ (function () {
    function PublicVideoApiService(httpClient) {
        var _this = this;
        this.httpClient = httpClient;
        this.getVideoUrls = function (videoId, channelId, instance, baseUrl) {
            if ((0, experiments_1.isGraphAPIEnabled)()) {
                if (channelId) {
                    var publicChannelService = new public_1.PublicChannelService(instance, baseUrl);
                    return publicChannelService.getChannelVideoPlayUrls(videoId, channelId);
                }
                var publicVideoService = new public_1.PublicVideoService(instance, baseUrl);
                return publicVideoService.getPlayUrls({
                    id: videoId,
                    type: public_1.VideoPlayType.CONTENT,
                });
            }
            return _this.siteBasedPublicVideoService
                .getVideoUrls(videoId, channelId, instance)
                .then(function (response) { return response.data; })
                .catch(to_error_1.toError);
        };
        this.getDownloadUrl = function (videoId, channelId, instance, baseUrl) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var publicVideoService;
            return tslib_1.__generator(this, function (_a) {
                if ((0, experiments_1.isGraphAPIEnabled)()) {
                    publicVideoService = new public_1.PublicVideoService(instance, baseUrl);
                    return [2 /*return*/, publicVideoService.getDownloadUrl(videoId)];
                }
                return [2 /*return*/, video_1.PublicVideo.getDownloadUrl(hosts_1.PRODUCTION_HOSTS.catalog, videoId, channelId, instance)];
            });
        }); };
        this.siteBasedPublicVideoService = new video_1.PublicVideo(httpClient);
    }
    return PublicVideoApiService;
}());
exports.PublicVideoApiService = PublicVideoApiService;
//# sourceMappingURL=video.js.map